import getApiClient from '@/plugins/api-client'
import axios from 'axios'
import Vue from 'vue'

export default {
  loadUser () {
    const api = getApiClient(this.$store)
    const userId = this.$route.params.id

    api.get(`users/${userId}`)
      .then(result => {
        if (!result.data.address) {
          result.data.address = {
            street: '',
            number: null,
            complement: '',
            neighborhood: '',
            city: '',
            state: '',
          }
        }
        this.user = result.data
      })
      .catch(error => {
        this.error = error.response
      })
  },

  loadAddressByZipCode (address) {
    const zipCode = address?.zipCode

    if (zipCode && zipCode.length === 8) {
      const endpoint = `https://viacep.com.br/ws/${zipCode}/json/`
      this.$store.commit('app/startLoading')
      axios.get(endpoint)
        .then((result) => {
          const data = result.data
          address.street = data.logradouro
          address.city = data.localidade
          address.neighborhood = data.bairro
          address.state = data.uf
        })
        .catch(() => {
        })
        .finally(() => {
          this.$store.commit('app/stopLoading')
        })
    }
  },

  updateProfile () {
    const api = getApiClient(this.$store)
    this.errors = {}

    api.patch(this.user['@id'], this.prepareProfile(), {
      headers: {
        'Content-Type': 'application/merge-patch+json',
      },
    })
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Perfil atualizado com sucesso')
      })
      .catch(error => {
        this.parseErrors(error.response.data)
        this.$store.commit('app/raiseError', 'Falha ao atualizar perfil')
      })
  },

  prepareProfile () {
    const result = {
      name: this.user.name,
      email: this.user.email,
      biography: this.user.biography,
      cpf: this.user.cpf,
      phone: this.user.phone,
      birthDate: this.user.birthDate,
      classValue: this.user.classValue,
    }

    if (this.user.address && this.role !== 'Administrador') {
      result.address = this.user.address

      if (!this.user.address.number) {
        this.$delete(this.user.address, 'number')
      }
    }

    if (this.user.password) {
      result.password = this.user.password
      result.passwordConfirmation = this.user.passwordConfirmation ?? ''
    }

    if (this.role === 'Professor') {
      result.resident = this.user.resident
      result.nativeSpeaker = this.user.nativeSpeaker
    }

    return result
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },

  setCalendarToday () {
    this.calendarFocus = ''
  },
  calendarPrev () {
    this.$refs.calendar.prev()
  },
  calendarNext () {
    this.$refs.calendar.next()
  },
  getCalendarEventColor (event) {
    return event.color
  },
  sendConfirmationEmail () {
    const api = getApiClient(this.$store)

    api.post('users/send_activation_link', {
      email: this.user.email,
    })
      .then(() => {
        this.$store.commit('app/raiseSuccess', 'Email enviado')
      })
      .catch(() => {
        this.$store.commit('app/raiseError', 'Erro ao enviar email de confirmação')
      })
  },
  activateAccount () {
    const api = getApiClient(this.$store)
    api.post(`/user/${this.user.id}/activate`, {
      token: '_default_admin_token_',
    })
      .then(result => {
        this.loadUser()
        this.$store.commit('app/raiseSuccess', 'Conta ativada com sucesso!')
      })
      .catch(error => {
        this.parseErrors(error.response.data)
        this.$store.commit('app/raiseError', 'Falha ao ativar conta')
      })
  },
}
